import { supabase } from "@/integrations/supabase/client";

export type DailyQuotaAction = "status" | "message" | "image" | "attachment";

export type DailyQuotaStatus = {
  allowed: boolean;
  tier?: string;
  limits?: { messages: number; images: number; attachments: number };
  used?: { messages: number; images: number; attachments: number };
  remaining?: { messages: number; images: number; attachments: number };
  reset_date?: string;
  reason?: string;
};

export const getDailyQuotaStatus = async (): Promise<DailyQuotaStatus> => {
  const { data, error } = await supabase.functions.invoke("daily-quota", {
    body: { action: "status" },
  });

  if (error) throw error;
  return (data?.data || data) as DailyQuotaStatus;
};

export const consumeDailyQuota = async (
  action: Exclude<DailyQuotaAction, "status">,
  units: number = 1
): Promise<DailyQuotaStatus> => {
  const { data, error } = await supabase.functions.invoke("daily-quota", {
    body: { action, units },
  });

  if (error) throw error;
  return (data?.data || data) as DailyQuotaStatus;
};
